import { FunctionComponent } from 'react';
import {
    CLARITY_LEVELS,
    BadgeContainer,
    ScoreLabel,
    DescriptionLabel
} from './styled';

interface Props {
    score: number;
}

const ClarityBadge: FunctionComponent<Props> = ({ score }) => {
    const level = CLARITY_LEVELS[score];
    if (!level) return null;

    const [, detail] = level.label.split(' — ');

    return (
        <BadgeContainer themeColor={level.color} themeBg={level.bg}>
            <ScoreLabel themeColor={level.color} themeBg={level.bg}>
                Clarity {score}/4
            </ScoreLabel>
            <DescriptionLabel themeColor={level.color} themeBg={level.bg}>
                — {detail}
            </DescriptionLabel>
        </BadgeContainer>
    );
};

export default ClarityBadge;
